export function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  //если мы здесь, значит случайно включили CoreModule в двух и более местах
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}
